import script from "./storagePayDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./storagePayDetail.vue?vue&type=script&setup=true&lang=js"

import "./storagePayDetail.vue?vue&type=style&index=0&id=a926f4ea&lang=less"

const __exports__ = script;

export default __exports__